import React from 'react';
import { Link } from 'react-router-dom';
import { Button, Row, Col, Form } from 'react-bootstrap';
import MailIcon from '../assets/images/icons/mail-icon.svg';

export const ContactUs = () => {

    return (
        <div className="ContactUs-Page">
            {/* Breadcrumb Banner Section */}
            <section className="breadcrumb-banner-section py-5">
                <div className="container-xl position-relative z-1">
                    <div className="page-header text-white text-uppercase text-center">
                        <div className="section-heading text-white lh-sm mb-2">Contact Us</div>
                        <ul className="list-unstyled d-flex justify-content-center gap-2 mb-0">
                            <li className="text-white">Home</li>
                            <li>
                                <span>/</span>
                            </li>
                            <li className="text-primary">Contact</li>
                        </ul>
                    </div>
                </div>
            </section>

            {/* IWT Section */}
            <section className="iwt-section bg-white py-5">
                <div className="container-xl my-md-3">
                    <Row className="g-4 g-lg-5">
                        <Col md={6}>
                            <div data-aos="slide-right" className="item-wrapper h-100 position-relative rounded-4 overflow-hidden">
                                <img src={require('../assets/images/contact-img1.png')} className="img-fluid h-100 w-100 object-fit-cover rounded-4" alt="Practice Together" />
                                <div className="wrapper bg-black bg-opacity-50 d-flex flex-column align-items-start justify-content-center position-absolute start-0 top-0 end-0 bottom-0 p-3 p-md-4">
                                    <div className="contact-number mb-2 mb-md-3">
                                        <Link to={'tel:+1 3174576046'} className="d-inline-flex align-items-center gap-2 text-white text-decoration-none">
                                            <i className="bi bi-telephone-fill text-base text-primary lh-1"></i> +1 3174576046
                                        </Link>
                                    </div>
                                    <div className="contact-email mb-2 mb-md-3">
                                        <Link to={'mailto:yousseljesus@gmail.com'} className="d-inline-flex align-items-center gap-2 text-white text-decoration-none">
                                            <i className="bi bi-envelope-fill text-base text-primary lh-1"></i> yousseljesus@gmail.com
                                        </Link>
                                    </div>
                                    <div className="contact-address d-inline-flex align-items-center gap-2 text-white mb-2 mb-md-3">
                                        <i className="bi bi-geo-alt-fill text-base text-primary lh-1"></i> 801 Broken bow Trail, Indianapolis, Indiana 46214
                                    </div>
                                    <div className="btn-wrapper pt-2">
                                        <Button variant='theme1' className="btn-custom">Support Us</Button>
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col md={6}>
                            <div data-aos="slide-left" className="item-wrapper h-100 position-relative rounded-4 overflow-hidden">
                                <img src={require('../assets/images/practice-together.jpg')} className="img-fluid h-100 w-100 object-fit-cover rounded-4" alt="Practice Together" />
                                <div className="btn-wrapper bg-black bg-opacity-50 d-flex flex-column align-items-center justify-content-center position-absolute start-0 top-0 end-0 bottom-0 text-center">
                                    <div className="fs-2 fw-semibold text-white text-uppercase mb-4">Connect With Us</div>
                                    <div className="social-wrapper d-flex flex-wrap gap-5">
                                        <Link to={'tel:+911234567890'} target="_blank" rel="noopener noreferrer"><i className="bi bi-telephone fs-2 text-white"></i></Link>
                                        <Link to={'mailto:test@example.com'} target="_blank" rel="noopener noreferrer"><img src={MailIcon} alt='Mail Icon' className="img-fluid" style={{ width: '45px' }} /></Link>
                                        <Link to={'https://wa.me/'} target="_blank" rel="noopener noreferrer"><i className="bi bi-whatsapp fs-2 text-white"></i></Link>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </div>
            </section>

            {/* About Company Section */}
            <section className="contact-form-section bg-secondary bg-opacity-10 py-5">
                <div data-aos="slide-right" className="container-xl my-md-3">
                    <div className="section-heading-wrapper">
                        <div className="section-heading">Get in <span>Touch</span> Today!</div>
                        <div className="description">
                            I’d love to hear from you — whether it’s feedback, a project idea, or just a hello.
                            Let’s connect and see how we can create something meaningful together.
                        </div>
                    </div>
                    <Form className="form-wrapper mx-auto" style={{ maxWidth: '800px' }}>
                        <Row className="g-4">
                            <Col md={6}>
                                <Form.Group controlId="firstName">
                                    <Form.Label>First Name</Form.Label>
                                    <Form.Control type="text" placeholder="Enter your first name" className="px-3" required />
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group controlId="lastName">
                                    <Form.Label>Last Name</Form.Label>
                                    <Form.Control type="text" placeholder="Enter your last name" className="px-3" required />
                                </Form.Group>
                            </Col>

                            <Col md={6}>
                                <Form.Group controlId="email">
                                    <Form.Label>Email</Form.Label>
                                    <Form.Control type="email" placeholder="Enter your email" className="px-3" required />
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group controlId="phone">
                                    <Form.Label>Phone</Form.Label>
                                    <Form.Control type="text" placeholder="Enter your phone" className="px-3" required />
                                </Form.Group>
                            </Col>

                            <Col xs={12}>
                                <Form.Group controlId="message" className="mb-4">
                                    <Form.Label>Message</Form.Label>
                                    <Form.Control as="textarea" rows={5} placeholder="Enter your message" className="px-3" required />
                                </Form.Group>
                            </Col>
                        </Row>

                        <div className="btn-wrapper text-center pt-2">
                            <Button type="submit" variant='theme1' className="btn-custom">Submit</Button>
                        </div>
                    </Form>
                </div>
            </section>

            {/* Practice Together Section */}
            <section className="location-map-section">
                <iframe data-aos="zoom-in-up" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d14010.762569808528!2d77.22260517336503!3d28.60905606083897!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce2db961be393%3A0xf6c7ef5ee6dd10ae!2sIndia%20Gate%2C%20New%20Delhi%2C%20Delhi!5e0!3m2!1sen!2sin!4v1760511124725!5m2!1sen!2sin" className="border d-block w-100" style={{ minHeight: '350px', height: '65vh' }}
                    allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade" title="Yoospeak Office Location">
                </iframe>
            </section>
        </div>
    )
}
